import { createContext, useState } from "react";
import Lottie from "react-lottie";
import * as Loader from "../loader.json";
export const LoaderDisbatch = createContext(null);

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: Loader.default,
};

export default function LoaderContext({ children }) {
  const [loading, setLoading] = useState(false);
  return (
    <LoaderDisbatch.Provider value={setLoading}>
      <>
        {children}
        {loading && (
          <div
            style={{
              position: "fixed",
              left: 0,
              top: 0,
              bottom: 0,
              right: 0,
              zIndex: 90000,
              paddingTop: 100,
              boxSizing: "border-box",
              backgroundColor: "rgba(255, 255, 255,.8)",
            }}
          >
            <Lottie options={defaultOptions} height={100} width={100} />
          </div>
        )}
      </>
    </LoaderDisbatch.Provider>
  );
}
